import { useSelector } from "react-redux";

export const usePermission = (path) => {
  const permissions = useSelector((state) => state.permissions);
  if (!path) return permissions;
  return path.split(".").reduce((acc, key) => acc?.[key], permissions);
};
